export class TravelProductInformation {
    segmentSequence: number;
    flightDate: FlightDate;
    flightName: string;
    flightNumber: string;
    departureAirportCode: string;
    arrivalAirportCode: string;
    operatingCarrier: string;
    marketingCarrier: string;
    bookingClassDesignator: string;
    reservationBookingDesignator: string;
    duration: string;
    bookingClass: string;
    isDifferentFromLocation: boolean;
    fromTerminal: string;
    toTerminal: string;
    marriageGrp: string;
}

export class FlightDate {
    departureDate: string;
    departureTime: string;
    arrivalDate: string;
    arrivalTime: string;
}